import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('Tools',{staticClass:"tools-margin-top"}),_c(VMain,{staticClass:"rf-font-family"},[_c('router-view')],1),_c('Rodape')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }